import { TradeWay } from 'models/TradeWay';
import { connect } from 'react-redux';
import type { GreekLine } from 'state/quotes/details/details.model';
import type { SolveResultFormat } from 'state/quotes/results/result.model';
import {
  getFormQuoteDetails,
  getFormQuoteFxSpot,
  getFormQuoteResult,
  getFormQuoteState,
  getFormQuoteYield,
  getQuotePricerToBookingInvertedFlow,
  getQuoteRemunerationMode,
  getSidePanelTradeWayOrDefault,
} from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

import type { FlowWay } from '../cashFlowWayUtils';
import { getQuoteFlowWay } from '../cashFlowWayUtils';
export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  solvingMode: string | undefined;
  isMultipleSolvingMode: boolean;
  solveResult: number;
  solveResultFormat?: SolveResultFormat;
  isPriceInconsistentWithForm: boolean;
  pricedOn: string;
  tradeWay: TradeWay;
  flowWay: FlowWay;
  fxSpot: GreekLine | null;
  remunerationMode: string;
  enableReprice?: boolean;
  quoteYield?: string;
}

export type QuotedState = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const quoteType = getFormQuoteState(state, workspaceType, tabId);
  const quoteResult = getFormQuoteResult(state, workspaceType, tabId)!;
  const quoteDetails = getFormQuoteDetails(state, workspaceType, tabId)!;
  const remunerationMode = getQuoteRemunerationMode(state, tabId);
  const tradeWay = getSidePanelTradeWayOrDefault(state, tabId);
  const fxSpot = getFormQuoteFxSpot(state, workspaceType, tabId);
  const quoteYield = getFormQuoteYield(state, workspaceType, tabId);

  const solveResult = quoteResult?.solveResult!;
  const solveResultFormat = quoteResult?.solveResultFormat;
  const solvingModeDetail = quoteDetails?.SolvingMode;
  const solvingMode = solvingModeDetail?.label ?? solvingModeDetail?.id;

  const pricerToBookingInvertedFlow = getQuotePricerToBookingInvertedFlow(state, workspaceType, tabId);

  const flowWay = getQuoteFlowWay(
    workspaceType,
    pricerToBookingInvertedFlow,
    solvingMode,
    remunerationMode,
    solveResult,
    tradeWay,
  );

  return {
    solveResult,
    solveResultFormat,
    solvingMode,
    isMultipleSolvingMode: quoteDetails?.IsMultipleSolvingMode ?? false,
    pricedOn: quoteResult.createdAt!,
    tradeWay,
    flowWay,
    isPriceInconsistentWithForm: quoteType === 'Inconsistent',
    fxSpot,
    remunerationMode,
    quoteYield,
  };
};

export const connectQuotedPreviously = connect(mapStateToProps);
